(() => {
  // app/scripts/popup-quick-shop.js
  customElements.define("popup-quick-shop", class extends HTMLElement {
    constructor() {
      super();
      this.productUrl = this.dataset.productUrl;
      const btnTriggers = this.querySelectorAll("#popupQuickview .jsTrigger");
      btnTriggers?.forEach((btn) => {
        btn.addEventListener("click", () => {
          const e_parent = btn.parentElement;
          e_parent.classList.contains("active") ? e_parent.classList.remove("active") : e_parent.classList.add("active");
        });
      });
      let tab_controls = this.querySelectorAll(".tab_control");
      tab_controls?.forEach((e) => {
        e.addEventListener("click", (eve) => {
          eve.preventDefault();
          window.location.href = this.productUrl;
          localStorage.setItem("tab_control", e.dataset.target);
        });
      });
    }
  });
})();
